import React, { useRef, useState } from "react";
import { Box, Container, Grid } from "@mui/material";
import { toast } from "react-toastify";
import { Formik } from 'formik';
import { Typography, TextField } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getEmirates } from "../../utils/constants";
import { useSelector } from "react-redux";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import firebase from "firebase/app";
import { useDispatch } from "react-redux";
import { profileValidation } from '../../validators/profile';
import { useTranslation } from "react-i18next";
import moment from "moment";
import CountryPicker from "../../components/pickers/CountryPicker"
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PhoneInput from "react-phone-input-2";
import "../../components/bootstrap.css";
import parsePhoneNumber from 'libphonenumber-js'
import { loginSuccess, logoutSuccess } from '../../redux/reducers/auth.reducer';

const Profile = () => {
    const emarites = getEmirates();
    const genders = ["Male", "Female"];
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const [gender, setGender] = React.useState('');
    const [contryCode, setContryCode] = React.useState('');
    const userData = useSelector((state) => state.auth.user);
    const [emarite, setEmarite] = React.useState(userData?.emirate);
    const [imageAsFile, setImageAsFile] = useState('')
    const allInputs = { imgUrl: '' };
    const [imageAsUrl, setImageAsUrl] = useState(allInputs);
    const currenUser = firebase.auth().currentUser;
    const [dateNow, setDateNow] = useState(userData?.birthDate?.seconds ? new firebase.firestore.Timestamp(userData?.birthDate?.seconds, userData?.birthDate?.nanoseconds).toDate() : new Date());
    const imageInputRef = useRef(null);
    const formateDate = (date) => {
        console.log("date to formate : ", date);
        const year = date?.getFullYear();

        const monthWithOffset = date?.getUTCMonth() + 1;
        const month = monthWithOffset.toString().length < 2
            ? `0${monthWithOffset}`
            : monthWithOffset;
        const day =
            date?.getUTCDate()?.toString().length < 2
                ? `0${date?.getUTCDate()}`
                : date?.getUTCDate();

        const formatedDate = `${year}-${month}-${day}`;
        console.log("formated date  : ", formatedDate);

        return formatedDate;
    }
    const [phone, setPhone] = useState("");


    const materialDateInput = formateDate(dateNow);
    console.log(materialDateInput)

    const handleImageAsFile = (e) => {
        const image = e.target.files[0]
        setImageAsFile(imageFile => (image))
    }

    const handleEmariteChange = (event) => {
        setEmarite(event.target.value);
    };

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    React.useEffect(() => {
        if (userData && !!userData.birthDate) {
            const bd = new firebase.firestore.Timestamp(userData?.birthDate?.seconds, userData?.birthDate?.nanoseconds);
            setDateNow(bd?.toDate());
            console.log("userData.birthDate : ", userData.birthDate)
            console.log("bd : ", bd)
            console.log("bd?.toDate() : ", bd?.toDate())
        }
    }, [userData,])

    const handleSaveImage = (e) => {
        e.preventDefault()
        console.log('start of upload')
        // async magic goes here...
        const image = e.target.files[0]
        //setImageAsFile(imageFile => (image))
        if (image === '') {
            console.error(`not an image, the image file is a ${typeof (image)}`)
        }
        const uploadTask = firebase.storage().ref(`/images/${image.name}`).put(image)
        //initiates the firebase side uploading 
        uploadTask.on('state_changed',
            (snapShot) => {
                //takes a snap shot of the process as it is happening
                console.log(snapShot)
            }, (err) => {
                //catches the errors
                console.log(err)
            }, () => {
                // gets the functions from storage refences the image storage in firebase by the children
                // gets the download url then sets the image from firebase as the value for the imgUrl key:
                firebase.storage().ref('images').child(image.name).getDownloadURL()
                    .then(fireBaseUrl => {
                        setImageAsUrl(prevObject => ({ ...prevObject, imgUrl: fireBaseUrl }))
                    })
            })
        console.log("obj:", imageAsUrl.imgUrl)

    }

    return (
        <Container style={{ marginTop: "150px", backgroundColor: "rgba(250, 201, 4, 0.1)", width: "60%", height: "600px", border: "1px solid rgb(250, 201, 4)", borderRadius: "20px" }}>
            <Formik
                initialValues={{
                    email: userData.email,
                    nationality: userData.nationality,
                    fullName: userData.fullName,
                    gender: userData.gender,
                    phone: userData.phone,
                    //  phoneCountryCode : userData.phoneCountryCode,
                    birthDate: dateNow ? formateDate(dateNow) : formateDate(new Date())
                }}
                validationSchema={profileValidation}
                // validationSchema: Yup.object({
                //     email: Yup.string().required('Email is required').email('Please enter a valid email'),
                //     password: Yup.string().required('Password is required').min(8, 'Password must be at least 8 characters')
                // }),
                onSubmit={async (values) => {
                    console.log("values : ", values)
                    console.log("currenUser.uid : ", currenUser.uid)
                    await firebase.firestore().collection("users").doc(currenUser.uid).set({
                        email: values.email,
                        nationality: values.nationality,
                        fullName: values.fullName,
                        gender: values.gender,
                        phone: values.phone,
                        //  phoneCountryCode:values.phoneCountryCode,
                        birthDate: new Date(values.birthDate),
                        profileImage: imageAsUrl?.imgUrl ? imageAsUrl?.imgUrl : userData?.profileImage ?? ""
                    }, { merge: true })
                        .then(() => {
                            dispatch(loginSuccess({
                                id: currenUser?.uid,
                                email: values.email ?? currenUser?.email ?? "",
                                accessType: currenUser?.providerData[0]?.providerId ?? "email",
                                fullName: values.fullName ?? currenUser?.displayName ?? "",
                                phone: values.phone ?? "",
                                profileImage: imageAsUrl?.imgUrl ? imageAsUrl?.imgUrl : userData?.profileImage ?? "",
                                birthDate: new Date(values.birthDate),
                                gender: values.gender ?? "",
                                nationality: values.nationality ?? "",
                                isAnonymous: true
                            }));
                            console.log("successfully saved");
                            toast.success(t('users.updateProfileSuccess'));

                        })
                        .catch((err) => {
                            toast.error(t('compare.updateProfileError'));

                            console.error(err);
                        })
                }}
            >
                {
                    ({ handleChange, handleBlur, handleSubmit, values, errors, isValid, isSubmitting, dirty, setFieldValue }) => (
                        <>
                            <div style={{ height: "20px" }} />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography variant="body2" style={{ fontSize: "25px" }}>Edit Your Profile</Typography>
                                <Button onClick={handleSubmit} variant="contained" style={{ border: "1px solid rgb(250, 201, 4)", borderRadius: "20px" }}>Save changes</Button>
                            </div>
                            <Stack alignItems={"center"} display="flex" justifyContent={"center"} spacing={2}>
                                <Avatar
                                    alt={userData.fullName}
                                    src={imageAsUrl.imgUrl ? imageAsUrl.imgUrl : userData.profileImage}
                                    sx={{ width: 150, height: 150 }}
                                />
                                {/* <form onSubmit={(e) => handleSaveImage(e)}> */}
                                <input
                                    // allows you to reach into your file directory and upload image to the 
                                    style={{ display: "none" }}
                                    type="file"
                                    ref={imageInputRef}
                                    onChange={(e) => handleSaveImage(e)}
                                //onChange={handleImageAsFile}
                                />
                                <Button onClick={() => imageInputRef?.current?.click()} variant="contained" style={{ border: "1px solid rgb(250, 201, 4)", borderRadius: "20px" }}>Upload Image</Button>
                                {/* </form> */}
                                <div style={{ height: "20px" }} />
                            </Stack>
                            <Box
                                component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                                }}
                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                noValidate
                                autoComplete="off">
                                <TextField
                                    id="outlined-email"
                                    label="Email"
                                    variant="outlined"
                                    type={'email'}
                                    className='formInput'
                                    name="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    helperText={errors.email}
                                    error={!!errors.email}
                                />
                                <TextField
                                    id="outlined-password"
                                    label="Full Name"
                                    type={'text'}
                                    variant="outlined"
                                    className='formInput'
                                    name="fullName"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.fullName}
                                    helperText={errors.fullName}
                                    error={!!errors.fullName}
                                />
                                {/* <Button className='submitBtn' onClick={handleSubmit} disabled={!isValid} variant="contained">Login</Button> */}
                            </Box>

                            <Box
                                component="form"
                                sx={{
                                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                                }}
                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                                noValidate
                                autoComplete="off">
                                <FormControl error={!!errors.phone} style={{ m: 1, width: "25ch" }} >
                                    {/* <InputLabel id="PhoneNumberlabel">{"Phone Number"}</InputLabel> */}
                                    <PhoneInput
                                        country={"ae"}
                                        enableSearch={true}
                                        specialLabel="Phone Number"
                                        inputStyle={{ "-webkit-tap-highlight-color": "transparent", width: "-webkit-fill-available", backgroundColor: "rgb(254 249 233)", "-webkit-tap-highlight-color": "transparent", }}
                                        containerStyle={{ left: "-1ch", width: "-webkit-fill-available", backgroundColor: "rgb(254 249 233)", "-webkit-tap-highlight-color": "transparent", }}
                                        value={values.phone}
                                        isValid={!errors?.phone}
                                        defaultErrorMessage={errors.phone}
                                        enableAreaCodes
                                        countryCodeEditable={false}
                                        onBlur={handleBlur}
                                        inputProps={{
                                            id: "outlined-pnone",
                                        }}
                                        onChange={(val) => {
                                            console.log("errors.phone : ", errors)
                                            setFieldValue("phone", val)
                                        }}


                                    />
                                </FormControl>


                                <FormControl style={{ width: "25ch" }} >
                                    {/* <InputLabel id="birthDate-label">{"Birth Date"}</InputLabel> */}
                                    <TextField
                                        name="birthDate"
                                        label="Birth Date"
                                        InputLabelProps={{ shrink: true, required: true }}
                                        type="date"
                                        value={values.birthDate}
                                        onSelect={(e) => { console.log("event : ", e) }}
                                        onChange={(e) => { console.log("date  : ", e.target.value); if (!!e.target.value) { setFieldValue("birthDate", formateDate(new Date(e.target.value))); } }}
                                        onBlur={handleBlur}
                                        defaultValue={formateDate(dateNow)}
                                    />
                                </FormControl>

                            </Box>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", marginTop: "10px" }}>
                                <FormControl style={{ width: "55%" }} error={!!errors.nationality}>
                                    <InputLabel id="demo-simple-select-label">{t('users.nationality')}</InputLabel>
                                    <CountryPicker
                                    
                                        onChange={(e) => {
                                            console.log("e.target : ", e.target);
                                            setFieldValue("nationality", e.target.value)
                                        }}
                                        value={values.nationality}
                                        label={t('users.nationality')}
                                        name="nationality" labelId="demo-simple-select-label" id="demo-simple-select-label" />

                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "25px" }}>
                                <FormControl style={{ width: "55%" }} error={!!errors.gender} >
                                    <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Emarite"
                                        name="gender"
                                        onChange={(e) => {
                                            handleGenderChange(e);
                                            setFieldValue("gender", e.target.value)
                                        }}
                                        value={values.gender}
                                    >
                                        {genders.map((g) => (
                                            <MenuItem value={g}>{g}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>)
                }
            </Formik>
            <div style={{ height: "20px" }} />
        </Container>
    )
}

export default Profile;